import { useContext } from "react";
import { AuthContext } from "../../Moduels/Context/AuthContext";
import { normalizeRole, R } from "../../rbac/access";
import BrixigoPageLoader from "../common/BrixigoPageLoader";
import EmployeeDashboard from "./EmployeeDashboard";
import DashboardHome from "./DashboardHome";

export default function Dashboard() {
  const { role, loading } = useContext(AuthContext);
  if (loading) return <BrixigoPageLoader message="Loading dashboard…" />;
  if (normalizeRole(role) === R.EMPLOYEE) return <EmployeeDashboard />;
  return <DashboardHome />;
}
